var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossPlatformDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.65 2.24a1 1 0 0 0-1.3 1.52L19.796 5H19c-4.411 0-6.698 3.242-8.681 6.055l-.26.367C7.912 14.452 5.933 17 2 17a1 1 0 1 0 0 2c5.067 0 7.588-3.453 9.691-6.422l.07-.1C13.932 9.415 15.642 7 19 7h.797l-1.448 1.24a1 1 0 0 0 1.302 1.52l3.5-3a1 1 0 0 0 0-1.52zM2 5a1 1 0 1 0 0 2c2.318 0 3.94.884 5.31 2.19a1 1 0 1 0 1.38-1.446C7.03 6.158 4.932 5 2 5m17.707 9.293 2.992 2.992a1 1 0 0 1 .301.712v.018a1 1 0 0 1-.293.692l-3 3a1 1 0 1 1-1.414-1.414L19.586 19H19c-2.438 0-4.233-.988-5.687-2.364a1 1 0 0 1 1.374-1.453C15.862 16.295 17.187 17 19 17h.586l-1.293-1.293a1 1 0 0 1 1.414-1.414",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cross_svg__a)",
    fillRule: "evenodd",
    d: "M19.65 2.24a1 1 0 0 0-1.3 1.52L19.796 5H19c-4.411 0-6.698 3.242-8.681 6.055l-.26.367C7.912 14.452 5.933 17 2 17a1 1 0 1 0 0 2c5.067 0 7.588-3.453 9.691-6.422l.07-.1C13.932 9.415 15.642 7 19 7h.797l-1.448 1.24a1 1 0 0 0 1.302 1.52l3.5-3a1 1 0 0 0 0-1.52zM2 5a1 1 0 1 0 0 2c2.318 0 3.94.884 5.31 2.19a1 1 0 1 0 1.38-1.446C7.03 6.158 4.932 5 2 5m17.707 9.293 2.992 2.992a1 1 0 0 1 .301.712v.018a1 1 0 0 1-.293.692l-3 3a1 1 0 1 1-1.414-1.414L19.586 19H19c-2.438 0-4.233-.988-5.687-2.364a1 1 0 0 1 1.374-1.453C15.862 16.295 17.187 17 19 17h.586l-1.293-1.293a1 1 0 0 1 1.414-1.414",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cross_svg__a",
    x1: 12.25,
    x2: 12.25,
    y1: 2,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA68F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98363"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPlatformDevelopment);
export default __webpack_public_path__ + "static/media/cross-platform-development.f0bf91dd123a506110abd837a93723c7.svg";
export { ForwardRef as ReactComponent };